import Cookies from "js-cookie";

// See: Decoding signed cookies using JavaScript
// https://dev.to/ayushn21/demystifying-cookie-security-in-rails-6-1j2f
const decodeRailsSignedCookie = (signed) => {
  const value = unescape(signed.split("--")[0]);
  const payload = JSON.parse(atob(value));
  // eslint-disable-next-line no-underscore-dangle
  const decoded = atob(payload._rails.message);
  return JSON.parse(decoded);
};

export const anonToken = () => {
  const signedCookie = Cookies.get("anon_token");
  if (signedCookie) {
    return decodeRailsSignedCookie(signedCookie);
  }
  return null;
};

export const accessToken = () => {
  const signedCookie = Cookies.get("access_token");
  if (signedCookie) {
    return decodeRailsSignedCookie(signedCookie);
  }
  return null;
};

export const authenticatedHeadersHash = () => {
  const hash = {};

  const accessTok = accessToken();
  if (accessTok) {
    hash.Authorization = `Bearer ${accessTok}`;
  }

  const anonTok = anonToken();
  if (!anonTok) {
    throw new Error("anon_token missing! This is required in order for the app to function.");
  }
  hash.apikey = anonTok;

  if (globalThis && globalThis.Qwoted && globalThis.Qwoted.POSTGREST_API_SCHEMA) {
    hash["Accept-Profile"] = globalThis.Qwoted.POSTGREST_API_SCHEMA;
    hash["Content-Profile"] = globalThis.Qwoted.POSTGREST_API_SCHEMA;
  }

  return hash;
};

export const anonHeadersHash = () => {
  const hash = {};

  const anonTok = anonToken();
  if (!anonTok) {
    throw new Error("anon_token missing! This is required in order for the app to function.");
  }
  hash.apikey = anonTok;
  hash.Authorization = `Bearer ${anonTok}`;

  if (globalThis && globalThis.Qwoted && globalThis.Qwoted.POSTGREST_API_SCHEMA) {
    hash["Accept-Profile"] = globalThis.Qwoted.POSTGREST_API_SCHEMA;
    hash["Content-Profile"] = globalThis.Qwoted.POSTGREST_API_SCHEMA;
  }

  return hash;
};
